import { deleteMaguireAgencyMapping } from "../../../../../actions/Helper";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useDeleteMaguireAgencyMapping = () => {
  return useMutation(deleteMaguireAgencyMapping);
};
export default useDeleteMaguireAgencyMapping;
